<template>
    <div>
        <div class="bg">
            <div class="row button-placeholder">
                <div class="col-lg-3">
                    <div :id="'dt-length-' + shopId.toString() + '-' + productId" class="pull-left"></div>
                </div>
            </div>
            <div class="inner clearfix">
                <data-table
                    :length-handle="'#dt-length-' + shopId.toString() + '-' + productId"
                    :dt-id="shopId.toString() + '-' + productId"
                    :my-ajax="dataTableAjax"
                    :columns="columns"
                    :column-defs="columnDefs"
                    :refresh="DTRefresh"
                    :search="{
                    handle: '.dt-df-box',
                        placeholder: t('Name / Index / Ean')
                    }"
                    :page-length="defaultFilter.pagination"
                    :sort="false"
                ></data-table>
            </div>
        </div>
    </div>
</template>

<script>
    import DataTable from "../DataTable.vue";

    export default
    {
        props: {
            shopId: {
                type: Number,
                required: true
            },
            productId: {
                type: Number,
                required: true
            },
            route: {
                type: Object
            }
        },
        components: {DataTable},
        data()
        {
            return {
                columns: [],
                filters: {},
                DTRefresh: false,
                columnDefs: [],
                defaultFilter: {
                    search: '',
                    pagination: 10,
                }
            };
        },
        mounted()
        {
            this.init();
        },
        computed: {
        },
        methods: {
            init()
            {
                this.$http.get(this.route.name + '/init-detail').then(response => {
                    this.columns = response.body.columns;
                    this.filters = response.body.filters;
                    this.DTRefresh = !this.DTRefresh;
                    this.columnDefs = this.buildColumnDefs();
                });
            },
            dataTableAjax(data, callback)
            {
                delete data.columns;
                data.shops = [this.shopId];
                data.product = this.productId;
                this.$buildFilters(this.filters, data);

                this.$http.get(this.route.name + '/dt-detail', {params: data}).then((response) => {
                    this.searchValue = response.body.searchValue;
                    callback(response.body)
                })
            },
            defaultFilterChange: function(defaultFilter) {
                this.defaultFilter = defaultFilter;
            },
            buildColumnDefs: function() {
                let _this = this;
                let boolColumnIndex = [];
                _this.columns.forEach(function(column, index) {
                    if (column.type === 'boolean') {
                        boolColumnIndex.push(index);
                    }
                });

                return [{
                    render: function (data, type, row, settings) {
                        if (true === data) {
                            return _this.$translate.text('Yes');
                        } else if (false === data) {
                            return _this.$translate.text('No');
                        }

                        return data ? data : '';
                    },
                    targets: boolColumnIndex
                }];
            }
        }
    }
</script>


<style lang="sass">
    .button-placeholder {
        padding-top: 3px;
    }
</style>


// WEBPACK FOOTER //
// StationaryShop.vue?08d63dad